/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonArticleTypeInfo,
    JsonArticleTypeInfoFromJSON,
    JsonArticleTypeInfoFromJSONTyped,
    JsonArticleTypeInfoToJSON,
} from './JsonArticleTypeInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonArticleTypeInfo
 */
export interface ApiResultOfListOfJsonArticleTypeInfo {
    /**
     * 
     * @type {Array<JsonArticleTypeInfo>}
     * @memberof ApiResultOfListOfJsonArticleTypeInfo
     */
    data?: Array<JsonArticleTypeInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticleTypeInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonArticleTypeInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticleTypeInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticleTypeInfo
     */
    result?: ApiResultOfListOfJsonArticleTypeInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonArticleTypeInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonArticleTypeInfoFromJSON(json: any): ApiResultOfListOfJsonArticleTypeInfo {
    return ApiResultOfListOfJsonArticleTypeInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonArticleTypeInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonArticleTypeInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonArticleTypeInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonArticleTypeInfoToJSON(value?: ApiResultOfListOfJsonArticleTypeInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonArticleTypeInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

